import React, { useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { testimonials, Testimonial } from '../data/content';
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-183" data-mp="3fxkusbssu7ki">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-[18px] w-[18px] fill-cobalt text-cobalt" aria-hidden="true" data-id="element-184" data-mp="36yzfcpimj8ny" data-mpi={i} />)}
    </div>;
}
function Card({
  t
}: {
  t: Testimonial;
}) {
  return <article className="flex h-full flex-col rounded-2xl border border-cobalt/20 bg-white p-6 shadow-sm shadow-cobalt/5" data-id="element-185" data-mp="321z8icdya1vs">
      <Stars data-id="element-186" data-mp="2s1qaqu4b88ea" />
      <p className="mt-4 flex-1 text-sm leading-relaxed text-ink/80" data-id="element-187" data-mp="2s28cu7dnlgu4">“{t.text}”</p>
      <div className="mt-6 flex items-center gap-3" data-id="element-188" data-mp="v9g9bl2obyo3">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-cobalt text-sm font-bold text-white" data-id="element-189" data-mp="v8ws66kuleb4">
          {t.initials}
        </span>
        <div data-id="element-190" data-mp="h5ornglmyga2">
          <p className="text-sm font-bold text-ink" data-id="element-191" data-mp="h4wtby0nm4g3">{t.name}</p>
          <p className="text-xs text-ink/60" data-id="element-192" data-mp="m4rmy9btd84u">{t.city}</p>
          <p className="text-xs italic text-cobalt-deep" data-id="element-193" data-mp="m6ch3xu7up26">{t.role}</p>
        </div>
      </div>
    </article>;
}
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const go = useCallback((dir: number) => {
    setIndex(prev => (prev + dir + testimonials.length) % testimonials.length);
  }, []);
  return <section className="w-full bg-white px-5 py-12 sm:py-20" data-id="element-194" data-mp="14vj0ln2u3kp1">
      <div className="mx-auto max-w-5xl" data-id="element-195" data-mp="14ur66fkz3t0c">
        <div className="mx-auto max-w-2xl text-center" data-id="element-196" data-mp="q6wb4sjhtck3">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-197" data-mp="q6cvxjl8929r">
            What Chemistry teachers say
          </h2>
          <p className="mt-3 text-sm text-ink/70 sm:text-base" data-id="element-198" data-mp="1iv1yzo5ufho5">
            <span className="text-cobalt" data-id="element-199" data-mp="1ith39v7slsop">⭐⭐⭐⭐⭐</span> 4.9/5 · Trusted by teachers across the
            USA, UK &amp; Canada
          </p>
        </div>

        <div className="mt-10 hidden gap-6 md:grid md:grid-cols-3" data-id="element-200" data-mp="1xgpkpdrp2u94">
          {testimonials.map(t => <Card key={t.name} t={t} data-id="element-201" data-mp="1sk7fydwd6vws" />)}
        </div>

        <div className="mt-10 md:hidden" data-id="element-202" data-mp="1ogt0ppg92jke">
          <div className="relative overflow-hidden" data-id="element-203" data-mp="1ofrh2wl64or2">
            <AnimatePresence mode="wait" data-id="element-204" data-mp="1jir9gh8o7dxu">
              <motion.div key={index} initial={{
              opacity: 0,
              x: 40
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -40
            }} transition={{
              duration: 0.3,
              ease: 'easeOut'
            }} data-id="element-205" data-mp="1jhpz6ezhavh6">
                <Card t={testimonials[index]} data-id="element-206" data-mp="14ud5u43fjlg8" />
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="mt-5 flex items-center justify-between" data-id="element-207" data-mp="10tb85rp5vhgd">
            <button type="button" onClick={() => go(-1)} aria-label="Previous testimonial" className="flex h-11 w-11 items-center justify-center rounded-full border border-cobalt/30 text-cobalt-deep transition-colors hover:bg-cobalt/10" data-id="element-208" data-mp="vswxs3037vf6">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-209" data-mp="37expj6v88nr2" />
            </button>

            <div className="flex gap-2" data-id="element-210" data-mp="3cetub8br0j7o">
              {testimonials.map((_, i) => <button key={i} type="button" onClick={() => setIndex(i)} aria-label={`Go to testimonial ${i + 1}`} className={`h-2 rounded-full transition-all ${i === index ? 'w-6 bg-cobalt' : 'w-2 bg-cobalt/30'}`} data-id="element-211" data-mp="3gh6y3r6xq71t" data-mpi={i} />)}
            </div>

            <button type="button" onClick={() => go(1)} aria-label="Next testimonial" className="flex h-11 w-11 items-center justify-center rounded-full border border-cobalt/30 text-cobalt-deep transition-colors hover:bg-cobalt/10" data-id="element-212" data-mp="2xickilj7jcn8">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-213" data-mp="1lwdej3zfbcgm" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}